import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "p-7" }
const _hoisted_2 = { class: "col-span-12 space-y-6" }
const _hoisted_3 = { class: "text-gray-400 text-sm mt-1" }
const _hoisted_4 = { class: "text-gray-400 text-sm mt-1" }
const _hoisted_5 = { class: "flex justify-end" }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FormSection from '@/components/FormSection.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import CKEditor from '@/components/inputs/CKEditor.vue';

import Pages from "@/classes/Pages";

import { PageInterface } from '@/interfaces/BaseInterface';

import { useRoute } from 'vue-router';
import { onMounted, ref } from 'vue';
import DropzoneInput from '@/components/inputs/DropzoneInput.vue';
import ListTable from '@/components/ListTable.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowPage',
  setup(__props) {

const route = useRoute();

// Data
const loader    = ref(false);
const showError = ref(false);
const errorMsg  = ref(null);
const errors      = ref([])
const showSuccess = ref(false)
const showConfirmation = ref(false)

const item = ref<PageInterface>({
    id: Number(route.params.id),
    title: '',
    sections: [],
    content: '',
});

const page = ref(null);
const schema = ref(null);

const form = ref({});

// Methods
const edit = () => {
    loader.value = true;

    Pages.show(route.params.id)
        .then((response: any) => {
            loader.value = false;

            console.log(response.data)
            page.value = response.data.page;
            schema.value = response.data.schema;

            form.value = buildFormData(page.value, schema.value)

        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

const update = () => {
    loader.value = true;

    // Pages.update(item.value.id, {
    //     content: item.value.content
    // })
    //     .then(() => {
    //         loader.value = false;
    //         showSuccess.value = true;
    //     })
    //     .catch((err) => {
    //         loader.value = false;
    //         showError.value = true;
    //         errorMsg.value = err.response.data.message;

    //         if(err.response.status == 422) {
    //             errors.value = err.response.data.errors;
    //         }
            
    //         if(err.response.status == 401) {
    //             window.location.replace('/login');
    //         }
    //     })

    const formData = new FormData();

    Object.entries(form.value).forEach(([key, value]) => {
        if (value === null || value === undefined) {
            // Skip null or undefined values
            return;
        }
        
        if (value instanceof File) {
            formData.append(key, value, value.name);
        } else if (Array.isArray(value)) {
            // if (value[0] instanceof File) {
            //     // Handle multiple file inputs
            //     value.forEach(file => {
            //         formData.append(key, file, file.name);
            //     });
            // } else {
            //     // Handle other array values
            //     value.forEach((item, index) => {
            //         formData.append(`${key}[${index}]`, item);
            //     });
            // }
            value.forEach((item, index) => {
                formData.append(`${key}[${index}]`, item);
            });
        } else {
            formData.append(key, value);
        }
    });


    // for (const [key, value] of formData.entries()) {
    //     if (value instanceof File) {
    //         console.log(key, ':', value.name, '(File)');
    //     } else {
    //         console.log(key, ':', value);
    //     }
    // }

    Pages.update(route.params.id, formData)
        .then(() => {
            loader.value = false;
            showSuccess.value = true;
        })
        .catch((err) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = err.response.data.message;

            if(err.response.status == 422) {
                errors.value = err.response.data.errors;
            }
            
            if(err.response.status == 401) {
                window.location.replace('/login');
            }
        })
}

function updateList(event: any) {
    const keys = Object.keys(event.form);
    switch (event.action) {
      case "create":
        keys.forEach((key) => {
            if (!Array.isArray(form.value[key])) {
                form.value[key] = [];
            }
            form.value[key].push(event.form[key]);
        });
        break;
      case "edit":
        keys.forEach((key) => {
          form.value[key][event.selectedIndex] = event.form[key];
        });
        break;
      case "delete":
        keys.forEach((key) => {
          form.value[key].splice(event.selectedIndex, 1);
        });
        break;
      case "reorder":
        keys.forEach((key) => {
          form.value[key] = event.order.map((order) => {
            return form.value[key][order];
          });
        });
        break;
    }
  }

function buildFormData(page, schema) {
    const data = {
        title: page.title || null,
        description: page.description || null,
        keywords: page.keywords || null,
        robots_follow: page.robots_follow || true,
        robots_index: page.robots_index || true,
    };
    schema.sections.forEach((section) => {
        section.items.forEach((item) => {
        // get value from page
        const content = page.content;
        // console.log(content);
        if (item.type === "list_table") {
            // list items
            item.items.forEach((listItem) => {
                const contentId = `${section.id}_${item.id}`;
                const id = `${contentId}_${listItem.id}`;
                data[id] = [];
                if (listItem.type === "image") {
                    data[`${id}_file`] = [];
                }

                if (content && content[contentId] && content[contentId].length) {
                    content[contentId].forEach((contentItem) => {
                    data[id].push(contentItem[listItem.id]);
                    if (listItem.type === "image") {
                        data[`${id}_file`].push(null);
                    }
                    });
                }
            });
        } else {
            // normal items
            data[`${section.id}_${item.id}`] = content
                ? content[`${section.id}_${item.id}`] || null
                : null;
        }
        if (item.type === "image") {
            data[`${section.id}_${item.id}_file`] = null;
        }
        });
    });
    return data;
}


onMounted( () => {
    edit();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, {
    title: `View ${page.value?.label ?? '--'}`,
    "show-back": "",
    backUrl: "/contents/pages/index"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schema.value?.sections, (section) => {
          return (_openBlock(), _createBlock(FormSection, {
            key: section.id
          }, _createSlots({
            title: _withCtx(() => [
              _createTextVNode(_toDisplayString(section?.label), 1)
            ]),
            form: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.items, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id
                  }, [
                    (item.type === 'htmleditor')
                      ? (_openBlock(), _createBlock(CKEditor, {
                          key: 0,
                          modelValue: form.value[section.id + '_' + item.id],
                          "onUpdate:modelValue": ($event: any) => ((form.value[section.id + '_' + item.id]) = $event),
                          label: "Body",
                          id: "body",
                          config: {}
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true),
                    (item.type === 'image')
                      ? (_openBlock(), _createBlock(DropzoneInput, {
                          key: 1,
                          path: form.value[section.id + '_' + item.id],
                          "onUpdate:path": ($event: any) => ((form.value[section.id + '_' + item.id]) = $event),
                          file: form.value[section.id + '_' + item.id + '_file'],
                          "onUpdate:file": ($event: any) => ((form.value[section.id + '_' + item.id + '_file']) = $event),
                          label: item.label,
                          accept: '.png,.jpeg,.jpg,.webp'
                        }, null, 8, ["path", "onUpdate:path", "file", "onUpdate:file", "label"]))
                      : _createCommentVNode("", true),
                    (item.type === 'text')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createVNode(TextInput, {
                            modelValue: form.value[section.id + '_' + item.id],
                            "onUpdate:modelValue": ($event: any) => ((form.value[section.id + '_' + item.id]) = $event),
                            label: item.label,
                            id: `${section.id}_${item.id}`
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "id"]),
                          _createElementVNode("p", _hoisted_3, _toDisplayString(item.description), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (item.type === 'textarea')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createVNode(TextInput, {
                            modelValue: form.value[section.id + '_' + item.id],
                            "onUpdate:modelValue": ($event: any) => ((form.value[section.id + '_' + item.id]) = $event),
                            label: item.label,
                            textarea: "",
                            id: `${section.id}_${item.id}`
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "id"]),
                          _createElementVNode("p", _hoisted_4, _toDisplayString(item.description), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (item.type === 'list_table')
                      ? (_openBlock(), _createBlock(ListTable, {
                          key: 4,
                          list: item,
                          items: item.items,
                          id: section.id + '_' + item.id,
                          form: form.value,
                          onUpdateList: updateList
                        }, null, 8, ["list", "items", "id", "form"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]),
            _: 2
          }, [
            (section.description)
              ? {
                  name: "description",
                  fn: _withCtx(() => [
                    _createTextVNode(_toDisplayString(section.description), 1)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1024))
        }), 128)),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.$hasPermission('update-content'))
            ? (_openBlock(), _createBlock(ButtonComponent, {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showConfirmation.value = true))
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" Save Changes ", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[1] || (_cache[1] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Confirm",
        title: `${page.value?.label} Updated!`,
        content: `${page.value?.label} has been updated successfully`
      }, null, 8, ["show", "title", "content"]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[5] || (_cache[5] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[6] || (_cache[6] = ($event: any) => {showConfirmation.value = false; update() }),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: `Update ${page.value?.label}?`,
        content: `Are you sure you wish to update this ${page.value?.label}?`
      }, null, 8, ["show", "title", "content"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})